import { render } from "./PageOpenRuleEditor.vue?vue&type=template&id=266d9215&scoped=true"
import script from "./PageOpenRuleEditor.vue?vue&type=script&lang=js"
export * from "./PageOpenRuleEditor.vue?vue&type=script&lang=js"

import "./PageOpenRuleEditor.vue?vue&type=style&index=0&id=266d9215&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266d9215"]])

export default __exports__